import React from "react";
import ReportManager, {
  totalsColumns,
  totalsTransformer,
} from "commons/components/ReportManager";

const filters = [
  { type: "filter", name: "facilities", key: "facility_id" },
  {
    type: "filter",
    name: "users",
    key: "user_id",
    extras: { optionLabel: "username" },
  },
  { type: "filter", name: "suppliers", key: "supplier_id" },
];

const columns = [
  {
    name: "user",
    type: "text",
  },
  ...totalsColumns,
];

const byUserID = (record) => record.user_id + "";

export default function PurchasesByUser() {
  return (
    <ReportManager
      url="purchases"
      title="purchasesByUser"
      filterByDate
      filters={filters}
      columns={columns}
      totals={[
        "number_of_operations",
        "subtotal",
        "discount",
        "tax",
        "total",
        "cost",
      ]}
      recordsFunc={totalsTransformer(byUserID, "user_id")}
    />
  );
}
